<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row type="flex">
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规则类型" prop="ruleType">
              <j-dict-select-tag
                dictCode="rule_type"
                placeholder="请选择规则类型"
                type="list"
                v-model="model.ruleType"
              />
            </a-form-model-item>
          </a-col>

          <!-- <a-col :span="12" v-if="displayTimespan">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="回查时间" prop="timespan">
              <j-dict-select-tag
                dictCode="timespan"
                placeholder="请选择回查时间"
                type="list"
                v-model="model.timespan"
              />
            </a-form-model-item>
          </a-col> -->

          <a-col :span="24">
            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="测点类型" prop="pointType">
                <j-dict-select-tag
                  dictCode="point_data_type"
                  placeholder="请选择测点类型"
                  type="list"
                  v-model="model.pointType"
                  @change="handleSearch"
                />
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="测点名称" prop="pointName">
                <a-col :span="16">
                  <a-input placeholder="请输入测点名称" v-model="model.pointName"></a-input>
                </a-col>
                <a-col :span="2">
                  <a-button @click="handleSearch" icon="search" type="primary">搜索</a-button>
                </a-col>
              </a-form-model-item>
            </a-col>

            <a-col :span="24">
              <a-table
                :columns="columns"
                :dataSource="dataSource"
                :loading="loading"
                :pagination="ipagination"
                :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                @change="handleTableChange"
                bordered
                ref="table"
                rowKey="id"
                size="middle"
              >
                <span slot="action" slot-scope="text, record">
                  <a @click="dataLine(record)">历史数据</a>
                </span>
              </a-table>
            </a-col>
          </a-col>

          <!-- <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="持续时间" prop="duration">
              <j-dict-select-tag dictCode="duration" placeholder="请选择持续时间" type="list" v-model="model.duration" />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="检查周期" prop="period">
              <j-dict-select-tag dictCode="period" placeholder="请选择检查周期" type="list" v-model="model.period" />
            </a-form-model-item>
          </a-col> -->

          <a-col :span="12" v-if="model.pointType === 'float32'">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="高1" prop="high1">
              <a-col :span="17">
                <a-input placeholder="报警值" type="number" v-model.number="model.high1" />
              </a-col>
              <a-tag color="gold">一般告警</a-tag>
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="高2" prop="high2">
              <a-col :span="17">
                <a-input placeholder="报警值" type="number" v-model.number="model.high2" />
              </a-col>
              <a-tag color="red">严重告警</a-tag>
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="高3" prop="high3">
              <a-col :span="17">
                <a-input placeholder="报警值" type="number" v-model.number="model.high3" />
              </a-col>
              <a-tag color="magenta">紧急告警</a-tag>
            </a-form-model-item>
          </a-col>

          <a-col :span="12" v-if="model.pointType === 'float32'">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="低1" prop="low1">
              <a-col :span="17">
                <a-input placeholder="报警值" type="number" v-model.number="model.low1" />
              </a-col>
              <a-tag color="gold">一般告警</a-tag>
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="低2" prop="low2">
              <a-col :span="17">
                <a-input placeholder="报警值" type="number" v-model.number="model.low2" />
              </a-col>
              <a-tag color="red">严重告警</a-tag>
            </a-form-model-item>
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="低3" prop="low3">
              <a-col :span="17">
                <a-input placeholder="报警值" type="number" v-model.number="model.low3" />
              </a-col>
              <a-tag color="magenta">紧急告警</a-tag>
            </a-form-model-item>
          </a-col>

          <a-col :span="12" v-if="model.pointType === 'BOOL'">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态量" prop="switchStatus">
              <j-dict-select-tag
                dictCode="switch_status"
                placeholder="请选择状态量"
                type="radioButton"
                v-model="model.switchStatus"
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="12" v-if="model.pointType == 'int'">
            <template>
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="告警值" prop="digitalValues">
                <a-input placeholder="告警值" v-model="model.digitalValues" />
              </a-form-model-item>
            </template>
          </a-col>

          <a-col :span="12" v-if="model.pointType !== 'float32'">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="告警级别" prop="alertLevel">
              <j-dict-select-tag
                dictCode="alert_level"
                placeholder="请选择告警级别"
                type="radioButton"
                v-model="model.alertLevel"
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="24" v-if="model.pointType != 'float32'">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="告警信息" prop="remark">
              <a-textarea isMultiple v-model="model.summary" rows="4"></a-textarea>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="告警通知" prop="notifications">
              <a-select mode="multiple" placeholder="请选择告警通知" v-model="selectedPushTarget">
                <a-select-option :key="item.value" :value="item.value" v-for="item in alertPushOptions">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="7">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="启用状态" prop="enable">
              <a-switch checkedChildren="启用" unCheckedChildren="禁用" v-model="model.enable" />
            </a-form-model-item>
          </a-col>
          <a-col :span="5" v-if="model.pointType != 'float32'">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="语音播报" prop="isBroadcast">
              <a-switch checkedChildren="启用" unCheckedChildren="禁用" v-model="model.isBroadcast" />
            </a-form-model-item>
          </a-col>

          <a-col :span="24" v-if="model.pointType == 'float32'">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="语音播报" prop="floatBroadcasts">
              <j-multi-select-tag v-model="model.floatBroadcasts" :options="floatBroadcastsOptions" type="checkbox">
              </j-multi-select-tag>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <points-line-chart-modal ref="pointsDataLineModal"></points-line-chart-modal>
  </a-spin>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import { filter } from 'vuedraggable'
import PointsLineChartModal from '@views/monitor/datas/modules/PointsLineChartModal'
import moment from 'dayjs'

export default {
  name: 'AlertRuleForm',
  mixins: [JeecgListMixin],
  components: {
    PointsLineChartModal
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      innerData: [],
      columns: [
        {
          title: '测点名称',
          align: 'center',
          dataIndex: 'pointName',
          sorter: true
        },
        {
          title: '测点编码',
          align: 'center',
          dataIndex: 'pointCode',
          scopedSlots: { customRender: 'pointCode' },
          sorter: true
        },
        {
          title: '当前值',
          align: 'center',
          dataIndex: 'timeSeriesDetail.value'
        },
        {
          title: '当前值时间戳',
          align: 'center',
          dataIndex: 'timeSeriesDetail.timeStamp'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      model: {
        pointName: '',
        pointCode: '',
        pointType: 'float32',
        parameter: '',
        timespan: '1m',
        expression: '',
        customLabel: '',
        duration: '0',
        period: '0',
        summary: '',
        enable: true,
        isBroadcast: true,
        ruleType: '1',
        alertLevel: '3',
        notifications: [],
        high1: '',
        high2: '',
        high3: '',
        low1: '',
        low2: '',
        low3: '',
        floatBroadcasts: 'high1,high2,high3,low1,low2,low3',
        highCase: 0,
        lowCase: 0,
        switchStatus: null,
        digitalValues: ''
      },
      alertPushOptions: [],
      pointOptions: [],
      selectedPushTarget: [],
      displayTimespan: true,
      displaySwitchStatus: false,
      floatBroadcastsOptions: [
        {
          label: '高1',
          value: 'high1'
        },
        {
          label: '高2',
          value: 'high2'
        },
        {
          label: '高3',
          value: 'high3'
        },
        {
          label: '低1',
          value: 'low1'
        },
        {
          label: '低2',
          value: 'low2'
        },
        {
          label: '低3',
          value: 'low3'
        }
      ],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      confirmLoading: false,
      validatorRules: {
        ruleType: [{ required: true, message: '请选择规则类型!' }],
        timespan: [{ required: true, message: '请选择回查时间!' }],
        digitalValues: [{ required: true, message: '请输入告警值!' }, { validator: this.vaInput }],
        switchStatus: [{ required: true, message: '请选择状态量切换!' }],
        alertLevel: [{ required: true, message: '请选择告警级别!' }],
        enable: [{ required: true, message: '请选择启用状态!' }]
      },
      url: {
        add: '/rule/alertRule/add',
        edit: '/rule/alertRule/edit',
        queryById: '/rule/alertRule/queryById',
        queryPushOptions: '/rule/alertPush/options',
        queryPointOptions: '/rule/alertRule/points',
        list: '/monitor/iotModelPoints/list'
      },
      selectPointOptions: []
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    }
  },
  beforeCreate() {
    this.disableMixinCreated = true
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))

    // 加载推送联系人
    let that = this
    this.alertPushOptions = getAction(this.url.queryPushOptions)
      .then(res => {
        if (res.success) {
          this.alertPushOptions = res.result
        } else {
          that.$message.warning(res.message)
        }
      })
      .finally(() => {
        that.confirmLoading = false
      })

    this.pointOptions = getAction(this.url.queryPointOptions)
      .then(res => {
        if (res.success) {
          this.pointOptions = res.result
        } else {
          that.$message.warning(res.message)
        }
      })
      .finally(() => {
        that.confirmLoading = false
      })
  },
  methods: {
    vaInput(rule, value, callback) {
      if (value) {
        const reg = /^(\d+,)*\d+$/
        if (!reg.test(value)) {
          callback(new Error('请输入数字量，多个数字用逗号隔开：1,2,3,4'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入数字量'))
      }
    },
    handleSearch() {
      this.dataSource = []
      this.loading = true
      this.queryParam = {
        dataType: this.model.pointType,
        pointName: this.model.pointName.length > 0 ? `*${this.model.pointName}*` : this.model.pointName,
        pageNo: this.ipagination.current
      }
      this.loadData()
    },

    filterPoint: function(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },

    searchPoint: value => {
      //判断value是否存在 如果存在就赋值, 这样select失去焦点后不会清空输入信息
      if (value) {
        this.model.pointCode = value
      }
    },

    changePoint: function(value, option) {
      if (value) {
        this.model.pointCode = value
        this.model.pointName = this.pointOptions[option.key].pointName
        this.model.pointType = this.pointOptions[option.key].pointType
      }
    },

    onSelectChange(selectedRowKeys, selectionRows) {
      console.log(selectedRowKeys, selectionRows)
      this.selectedRowKeys = selectedRowKeys
      this.selectPointOptions = selectionRows.map(({ pointCode, pointName, dataType }) => ({
        pointCode,
        pointName,
        dataType
      }))
      // this.model.pointCode = selectionRows[0].pointCode
      // this.model.pointName = selectionRows[0].pointName
      // this.model.pointType = selectionRows[0].dataType
    },

    add() {
      this.edit(this.modelDefault)
    },
    edit(record) {
      let transformRecord = record
      transformRecord.notifications.map(x => this.selectedPushTarget.push(x.id))
      this.model = Object.assign({}, transformRecord)

      this.queryParam = {
        pointCode: record.pointCode
      }
      this.loadData()
      this.visible = true
    },
    dataLine(record) {
      const pointCode = record.pointCode
      this.$refs.pointsDataLineModal.show(pointCode)
    },
    convertExpressionToResult(expression) {
      const numbers = expression.split(',')
      const conditions = numbers.map(number => `value == ${number}`)
      const result = conditions.join(' || ')
      return result
    },

    submitForm() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (!this.selectPointOptions.length && !this.model.id) {
          this.$message.warning('请至少选择一个测点')
          return
        }
        if (valid) {
          // 告警阈值校验
          if (that.model.pointType == 'float32') {
            that.model.isBroadcast = 1

            let high1 = that.model.high1
            let high2 = that.model.high2
            let high3 = that.model.high3
            let low1 = that.model.low1
            let low2 = that.model.low2
            let low3 = that.model.low3

            if (
              !high1 &&
              !high2 &&
              !high3 &&
              !low1 &&
              !low2 &&
              !low3 &&
              high1 + high2 + high3 + low1 + low2 + low3 === ''
            ) {
              this.$message.warning('至少填写一个告警阈值')
              return
            }

            if (typeof high1 == 'number' && typeof high2 !== 'number' && typeof high3 !== 'number') {
              console.log(1)
              that.model.highCase = 1
            } else if (typeof high1 !== 'number' && typeof high2 == 'number' && typeof high3 !== 'number') {
              console.log(2)
              that.model.highCase = 2
            } else if (typeof high1 !== 'number' && typeof high2 !== 'number' && typeof high3 == 'number') {
              console.log(3)
              that.model.highCase = 3
            } else if (typeof high1 == 'number' && typeof high2 == 'number' && typeof high3 !== 'number') {
              console.log(12)
              if (!(high1 < high2)) {
                this.$message.warning('告警阈值范围不正确：高1，高2')
                return
              }
              that.model.highCase = 4
            } else if (typeof high1 == 'number' && typeof high2 !== 'number' && typeof high3 == 'number') {
              console.log(13)
              if (!(high1 < high3)) {
                this.$message.warning('告警阈值范围不正确：高1，高3')
                return
              }
              that.model.highCase = 5
            } else if (typeof high1 !== 'number' && typeof high2 == 'number' && typeof high3 == 'number') {
              console.log(23)
              if (!(high2 < high3)) {
                this.$message.warning('告警阈值范围不正确：高2，高3')
                return
              }
              that.model.highCase = 6
            } else if (typeof high1 == 'number' && typeof high2 == 'number' && typeof high3 == 'number') {
              console.log(123)
              if (!(high1 < high2 && high2 < high3)) {
                this.$message.warning('告警阈值范围不正确：高1，高2，高3')
                return
              }
              that.model.highCase = 7
            }

            if (typeof low1 == 'number' && typeof low2 !== 'number' && typeof low3 !== 'number') {
              console.log(1)
              that.model.lowCase = 1
            } else if (typeof low1 !== 'number' && typeof low2 == 'number' && typeof low3 !== 'number') {
              console.log(2)
              that.model.lowCase = 2
            } else if (typeof low1 !== 'number' && typeof low2 !== 'number' && typeof low3 == 'number') {
              console.log(3)
              that.model.lowCase = 3
            } else if (typeof low1 == 'number' && typeof low2 == 'number' && typeof low3 !== 'number') {
              console.log(12)
              if (!(low1 > low2)) {
                this.$message.warning('告警阈值范围不正确：低1，低2')
                return
              }
              that.model.lowCase = 4
            } else if (typeof low1 == 'number' && typeof low2 !== 'number' && typeof low3 == 'number') {
              console.log(13)
              if (!(low1 > low3)) {
                this.$message.warning('告警阈值范围不正确：低1，低3')
                return
              }
              that.model.lowCase = 5
            } else if (typeof low1 !== 'number' && typeof low2 == 'number' && typeof low3 == 'number') {
              console.log(23)
              if (!(low2 > low3)) {
                this.$message.warning('告警阈值范围不正确：低2，低3')
                return
              }
              that.model.lowCase = 6
            } else if (typeof low1 == 'number' && typeof low2 == 'number' && typeof low3 == 'number') {
              console.log(123)
              if (!(low1 > low2 && low2 > low3)) {
                this.$message.warning('告警阈值范围不正确：低1，低2，低3')
                return
              }
              that.model.lowCase = 7
            }
          }

          that.confirmLoading = true

          const intParams =
            this.model.pointType === 'int'
              ? {
                  expression: this.convertExpressionToResult(this.model.digitalValues)
                }
              : {}

          if (this.model.id && !this.selectPointOptions.length) {
            this.selectPointOptions = this.dataSource.map(({ pointCode, pointName, dataType }) => ({
              pointCode,
              pointName,
              dataType
            }))
          }
          let params = this.selectPointOptions.map(({ pointCode, pointName, dataType }) => {
            return {
              ...this.model,
              pointCode,
              pointName,
              dataType,
              ...(this.model.pointType === 'int' ? intParams : {})
            }
          })
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
            params = Object.assign(params[0], { pointName: this.model.pointName }) //编辑接口接收非数组
          }

          httpAction(httpurl, params, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    handlePointsLineChart(record) {
      const timeRange = [
        moment(record.alertTime)
          .add(-1, 'hours')
          .format('YYYY-MM-DD HH:mm'),
        moment(record.alertTime)
          .add(1, 'hours')
          .format('YYYY-MM-DD HH:mm')
      ]
      const pointCode = record.pointCode
      this.$refs.pointsDataLineModal.show(pointCode, timeRange)
    }
  },
  watch: {
    // 动态显示必须的表单项
    'model.ruleType': {
      handler: function(newValue, oldValue) {
        if (newValue == 1) {
          this.displayTimespan = true
        } else if (newValue == 2 || newValue == 3) {
          this.displayTimespan = false
        } else if (newValue > 3) {
          this.displayTimespan = true
        }
      }
    },
    'model.pointType': {
      handler: function(newValue, oldValue) {
        if (newValue == 'BOOL') {
          this.displaySwitchStatus = true
          this.model.switchStatus = 1
        } else {
          this.displaySwitchStatus = false
          this.model.switchStatus = null
        }
      }
    },

    selectedPushTarget: {
      handler: function(newValue, oldValue) {
        this.model.notifications = []
        newValue.map(x => this.model.notifications.push({ id: x }))
      }
    }
  }
}
</script>
